import Button from "@/components/ui/button";
import { ButtonProps } from "@/components/ui/button";
import React from "react";
import { Link } from "react-router";

type Props = {
  path: string;
  children: React.ReactNode;
  disabled?: boolean;
  variant?: ButtonProps["variant"];
  size?: ButtonProps["size"];
  className?: string;
};

const LinkButton = React.forwardRef<HTMLButtonElement, Props>(
  ({ path, children, disabled, variant, size = "lg", className }, ref) => {
    if (disabled) {
      return (
        <Button
          ref={ref}
          disabled
          variant={variant}
          size={size}
          className={className}
          aria-disabled="true"
        >
          {children}
        </Button>
      );
    }

    // When enabled, we render the Button with `asChild` to pass its props
    // and styles to the underlying React Router Link.
    return (
      <Button
        asChild
        variant={variant}
        size={size}
        className={className}
        ref={ref}
      >
        <Link to={path} state={{ fromInternal: true }}>
          {children}
        </Link>
      </Button>
    );
  }
);

export default LinkButton;
